import React from 'react';

import './InsuranceTileContent.scss';
import { Package } from '../../../interfaces/Types';
import { FullCoverageCollection } from '../../../interfaces/Types';
import { CoverageDetails } from '../../CoverageList/CoverageDetails';
import { CoverageList } from '../../CoverageList/CoverageList';
import { TextHelper } from '../../../utils/TextHelper';

interface Props {
  data: Package;
}

export type ComponentProps = Props;

const InsuranceTileContent: React.FC<ComponentProps> = (props) => {
  const renderAdditionalPackageContent = () => {
    return (
      <div className="pluspacket-container">
        {props.data.detailText && (
          <CoverageDetails
            detailText={props.data.detailText}
            packageName={props.data.packageName}
            packagePrice={`${TextHelper.thousandSeparator(props.data.monthlyPrice)} ${props.data.currency}/mån`}
          />
        )}
        {props.data?.includedCoverages?.coverageList?.length > 0 && (
          <CoverageList
            coverages={props.data.includedCoverages.coverageList}
            isPlusPacket
            includedCoverage
          />
        )}
      </div>
    );
  };

  return (
    <>
        <div
          className={`tile-container-div`}
        >
            <div className="no-padding-right">
                {
                  renderAdditionalPackageContent()
                }
            </div>
        </div>
    </>
  );
};
export default InsuranceTileContent;
